"use client";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRouter } from "next/navigation";
import { toast } from "sonner";
import { z } from "zod";

import { FormInput } from "@/components/custom";
import { Button } from "@/components/ui/button";
import { Form, FormField } from "@/components/ui/form";
import { FORGOT_PASS_KEY } from "@/lib/constants";
import { storage } from "@/lib/utils";

import { asyncReqEmail } from "./actions";

const formSchema = z
  .object({
    email: z.string().email({ message: "Email хаяг буруу байна" }),
  })
  .required();

export default function ForgotForm() {
  const router = useRouter();
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
  });

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const { data, error } = await asyncReqEmail(values);

    if (!!data?.otpExpiryTime) {
      storage.set(FORGOT_PASS_KEY, {
        email: values.email,
        otpExpiryTime: data.otpExpiryTime ?? new Date(Date.now() + 600 * 1000),
      });
      router.push("/auth/forgot/verify");
    } else {
      toast.error(error, { position: "top-right" });
    }
  }

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="mt-4">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormInput placeholder="И-мэйл" field={field} />
          )}
        />
        <Button type="submit" className="!mt-20 rounded-2xl px-10">
          Үргэлжлүүлэх
        </Button>
      </form>
    </Form>
  );
}
